export const BASE_URL = "https://app.admind.ai/";

const getUrl = ()=>{
    if (process.env.REACT_APP_DEBUG==='1'){
        return process.env.REACT_APP_URL
    }else{
        return BASE_URL
    }
}
const backEnd = {
    url: `${getUrl()}api/`,
};

export default backEnd;
